import React from "react";
import { Form } from "react-bootstrap";

export default (props) => {
  return (
    <div className="bg-white p-5">
      <Form
        className="flex flex-col space-y-8"
        onSubmit={(e) => {
          e.preventDefault();
        }}
        method="post"
        id="store"
      >
        {props.children}
      </Form>
    </div>

  );
};
